import React, { useEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {
  Grid
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FormatInputNumero, SelectAsincronico, SelectFree, TextFieldAutoComplete } from 'components';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red'
    }
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },

}));
export default function FormularioPropuesta(props) {
  const { errors, setValue, watch, ctlg, getValues, defaultItem, isEdicion, setCambio, temporal, setTemporal } = props;
  const classes = useStyles();
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const fechaActual = year + '-' + month + '-' + day;                 

  const cambioPersona = (e, value) => {
    if (value.length > 0) {
      setValue('persona', value);
      setCambio(true);
      setTemporal({...temporal,'persona':value});
    } else{
      setValue('persona', null);
      setTemporal({...temporal,'persona': null});
    }
  }

  const cambioTipoincidencia = (e, value) => {
    if (value) {
      setValue('tipoincidencia', value);
      setTemporal({...temporal,'tipoincidencia' : value});
      setCambio(true);
    } else{
      setValue('tipoincidencia', null);
      setTemporal({...temporal,'tipoincidencia':null});
    }
  }
  // useEffect(() =>{
  //   register('finicio', { required: { value: true, message: 'Campo requerido' } });
  //   register('ffin', { required: { value: true, message: 'Campo requerido' } });
  //   register('nhoras', { required: { value: true, message: 'Campo requerido' } });
  // //    {required:{ value: true, message: 'Campo requerido'} });
  //   register('comentario');
  //   if(defaultItem?.propuesta ){                                                           
  //     setValue('finicio', defaultItem.propuesta.finicio);
  //     setValue('ffin', defaultItem.propuesta.ffin);
  //     setValue('comentario', defaultItem.propuesta.comentario);
  //     setValue('nhoras', defaultItem.propuesta.nhoras);
  //   }else{
  //     setValue('finicio', fechaActual);
  //     setValue('ffin', fechaActual);
  //     setValue('nhoras', null);
  //     setValue('comentario', null);
  //   }
  // },[]);
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item md={4} xs={4}>
        <TextField
          variant="outlined" fullWidth size="small" label="FECHA DE INICIO" type="date" value={watch('finicio')} InputLabelProps={{ shrink: true }}
          name="finicio" onChange={(e) => { setValue('finicio', e.target.value); setValue('ffin', e.target.value); setCambio(true); setTemporal({...temporal, 'finicio':e.target.value, 'ffin': e.target.value}) }} //inputRef={register}
          error={Boolean(errors.finicio)} helperText={errors.finicio}/>
      </Grid>
      <Grid item md={4} xs={4}>
        <TextField InputProps={{ inputProps: { min: getValues('finicio') } }}
          variant="outlined" fullWidth size="small" label="FECHA DE TÉRMINO" type="date" value={watch('ffin')} InputLabelProps={{ shrink: true }}
          name="ffin" onChange={(e) => { setValue('ffin', e.target.value); setCambio(true); setTemporal({...temporal, 'ffin' : e.target.value}) }} //inputRef={register}
          error={Boolean(errors.ffin)} helperText={errors.ffin} />
      </Grid>
      <Grid item md={4} xs={4}>
        <TextField
          variant="outlined" fullWidth size="small" label="NO. DE HORAS DE TRABAJO" type="number" value={watch('nhoras')} InputLabelProps={{ shrink: true }}
          name="nhoras" onChange={(e) => { setValue('nhoras', e.target.value); setCambio(true); setTemporal({...temporal, 'nhoras' : e.target.value}) }} //inputRef={register}
          error={Boolean(errors.nhoras)} helperText={errors.nhoras} />
      </Grid>
      
      {defaultItem.general.tipo_solicitud == 2 && <Grid item md={12} xs={12}>
        <Autocomplete
          options={ctlg.tipoincidencias}
          getOptionLabel={(option) => option.ntipoincidencia}
          getOptionSelected={(option, value) => option.idtipoincidencia == value.idtipoincidencia}
          value={watch('tipoincidencia') || []}
          onChange={cambioTipoincidencia}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField label="TIPO DE INCIDENCIA" variant="outlined" {...params}
              error={errors.tipoincidencia != undefined} helperText={errors.tipoincidencia}
            />
          )}
        />
      </Grid>}
      <Grid item md={12} xs={12}>
        <Autocomplete
          multiple
          options={ctlg.personas}
          getOptionLabel={(option) => option.npersona}
          getOptionSelected={(option, value) => option.idpersona == value.idpersona}
          value={watch('persona') || []}
          onChange={cambioPersona}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField label="MIEMBROS DEL EQUIPO" variant="outlined" {...params}
              error={errors.persona != undefined} helperText={errors.persona}
            />
          )}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <TextField size="small" multiline error={Boolean(errors.comentario)} rows='4' helperText={errors.comentario} onChange={(e) =>{ setValue('comentario', e.target.value); setTemporal({...temporal, 'comentario' : e.target.value})} }
          variant="outlined" fullWidth label="ACTIVIDADES A DESARROLLAR" placeholder="DESCRIPCIÓN DETALLADA DE ACTIVIDADES A DESARROLLAR" name="comentario" value={watch('comentario')} disabled={isEdicion} />
      </Grid>
      <Grid item md={12} xs={12}>
        {/* { ( (defaultItem.propuesta?.observacion) || (defaultItem.general?.estatusPropuesta == 7) ) && */}
        <TextField size="small" multiline error={Boolean(errors.observacion)} rows='4' helperText={errors.observacion} onChange={(e) =>{ setValue('observacion', e.target.value); setTemporal({...temporal, 'observacion' : e.target.value})}}
          variant="outlined" fullWidth label="COMENTARIO" name="observacion" value={watch('observacion')} />
        {/* } */}
      </Grid>
    </Grid>

  );
}
